<div class="container" role="main">
    <div class="HmsContainer">
        <form class="providerForm">
            <div class="row">
                <div class="row HmsInsideContainer">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-padding-left">
                        <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go To
                            Previous
                            Section</button>&nbsp;
                        <button type="button" class="greyBtn" *ngIf="isInstruction" (click)="openInstruction()"
                            style="font-weight : bold;">Instructions</button>&nbsp;
                        <button type="button" class="orangeBtn ml-5" *ngIf="isFormsValid"
                            (click)="nonEnumeratedOrganizationDetailsSubmit()"  [disabled]="!nonEnumeratedOrganizationFormPart1.valid || !nonEnumeratedOrganizationFormPart2.valid"
                            [ngStyle]="{'background-color': primaryColor}">Proceed
                            to Next Section</button>
                    </div>
                </div>
                <div class="row HmsInsideContainer">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-padding-left">
                        <p role="heading" aria-level="1">Please enter any information you have regarding the {{title}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="row HmsInsideContainer" role="form">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="col-md-10">
                        <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedOrganizationFormData1.controls"
                            [formData]="nonEnumeratedOrganizationFormPart1" (valueChangeEvent)="valueChange($event)"
                            (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
                        <button type="button" class="orangeBtn" style="float:left;" *ngIf="isFormsValid"
                            (click)="nonEnumeratedOrganizationDetailsSubmit()" [disabled]="!nonEnumeratedOrganizationFormPart1.valid || !nonEnumeratedOrganizationFormPart2.valid"
                            [ngStyle]="{'background-color': primaryColor}">Proceed
                            to Next Section</button>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="col-md-10">
                        <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedOrganizationFormData2.controls"
                            [formData]="nonEnumeratedOrganizationFormPart2" (valueChangeEvent)="valueChange($event)"
                            (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>